import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=3ab0d921&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab0d921')) {
      api.createRecord('3ab0d921', component.options)
    } else {
      api.reload('3ab0d921', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=3ab0d921&", function () {
      api.rerender('3ab0d921', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/registeruser/Register.vue"
export default component.exports